/**
 * Collection-Pagination: Zurueck-Taste reparieren
 * ---------------------------------------------------------------------------
 * Die Seitenlinks der Collection laufen per AJAX: `snippets/pagination.liquid`
 * wickelt sie in <facet-link>, das feuert `facet:update`, und der zentrale
 * Handler des Themes (assets/theme.js, "js/common/facets/facets-listeners.js")
 * macht darin `history.replaceState`.
 *
 * replaceState ERSETZT den aktuellen Verlaufseintrag, statt einen neuen
 * anzulegen. Die Collection-URL ohne `page` landet damit nie im Verlauf, und
 * Zurueck fuehrt auf die Seite DAVOR statt auf Seite 1.
 *
 * Prestige macht das absichtlich, damit nicht jeder Filter-Klick einen
 * Verlaufseintrag erzeugt. Die Pagination haengt nur mit im selben Handler.
 *
 * LOESUNG, ohne theme.js anzufassen:
 *
 * 1. Ein Listener auf `window` in der CAPTURE-Phase sieht `facet:update`, bevor
 *    der Handler des Themes auf `document` (Bubble-Phase) drankommt. Ist es ein
 *    reiner Seitenwechsel — alle Parameter gleich ausser `page` —, pushen wir
 *    ein Duplikat der AKTUELLEN URL. Das folgende replaceState des Themes
 *    ueberschreibt dann dieses Duplikat statt des Originals. Unterm Strich
 *    genau pushState-Verhalten.
 *
 * 2. Ein `popstate`-Handler feuert `facet:update` mit der neuen URL erneut und
 *    nutzt damit die Fetch-, Render- und Scroll-Logik des Themes weiter. Ohne
 *    diesen Teil waere die Aenderung schaedlich: Zurueck wuerde die URL auf
 *    Seite 1 stellen, aber die Produkte von Seite 2 stehen lassen.
 *
 * Faellt das Event bei einem Prestige-Upgrade weg, greifen beide Listener
 * einfach nicht mehr und das Verhalten faellt auf den heutigen Stand zurueck.
 *
 * Klassisches Script, kein Modul — nichts Modul-Ladendes ueber die Importmap
 * (siehe docs/55, Firefox-Race).
 */
(function () {
  'use strict';

  // Die Section rendert dieses Script; bei jedem AJAX-Re-Render wird es erneut
  // eingefuegt und ausgefuehrt. Ohne Riegel saessen die Listener mehrfach.
  if (window.__tlPaginationHistory) return;
  window.__tlPaginationHistory = true;

  // Verhindert, dass unser eigenes, aus popstate gefeuertes facet:update
  // wiederum einen Verlaufseintrag pusht.
  var replaying = false;

  // Pfad beim Laden. Ein popstate auf einen anderen Pfad gehoert nicht uns.
  var basePath = window.location.pathname;

  function marker() {
    return document.querySelector('[data-tl-pagination-history]');
  }

  /** URL ohne `page` und `section_id`, Parameter sortiert — zum Vergleichen. */
  function withoutPage(href) {
    var u = new URL(href, window.location.origin);
    u.searchParams.delete('page');
    u.searchParams.delete('section_id');
    var parts = [];
    u.searchParams.forEach(function (value, key) { parts.push(key + '=' + value); });
    parts.sort();
    return u.pathname + '?' + parts.join('&');
  }

  function pageOf(href) {
    return new URL(href, window.location.origin).searchParams.get('page') || '1';
  }

  window.addEventListener('facet:update', function (event) {
    if (replaying) return;
    var target = event.detail && event.detail.url;
    if (!target) return;

    var current = window.location.href;
    target = target.toString();

    // Nur reine Seitenwechsel bekommen einen Verlaufseintrag. Ein Filter-Klick
    // loescht `page` mit und aendert weitere Parameter — der soll weiterhin
    // den aktuellen Eintrag ersetzen, sonst laeuft der Verlauf voll.
    if (withoutPage(target) !== withoutPage(current)) return;
    if (pageOf(target) === pageOf(current)) return;

    try {
      history.pushState({ tlPaginationHistory: true }, '', current);
    } catch (e) {
      /* pushState kann in exotischen Kontexten werfen — dann bleibt es beim
         bisherigen Verhalten, nichts geht kaputt. */
    }
  }, true);

  window.addEventListener('popstate', function () {
    if (window.location.pathname !== basePath) return;

    var el = marker();
    if (!el) return;

    var sectionId = el.getAttribute('data-tl-pagination-history');
    if (!sectionId) return;

    var url = new URL(window.location.href);
    url.searchParams.set('section_id', sectionId);

    // Das Theme liest section_id aus der URL, holt die Section und ersetzt den
    // Inhalt. Unser Riegel steht nur waehrend des synchronen Teils.
    replaying = true;
    el.dispatchEvent(new CustomEvent('facet:update', { bubbles: true, detail: { url: url } }));
    replaying = false;
  });
})();
